class ComparisonTool {
  readonly CHECKBOX_CHECKED_EVENT: string = 'comparisonCheckboxChecked';
  readonly PRODUCT_REMOVED_MODAL_EVENT: string = 'comparisonModalProductRemoved';

  subcategoryId: string;

  constructor() {
    this.subcategoryId = window._THULEDATA.ComparisonModal.SubcategoryId;

    this.setupCheckboxes();
    this.setupCheckboxEvents();
  }

  setupCheckboxes = () => {
    const productIdsJson = localStorage.getItem(this.subcategoryId);

    if (!productIdsJson) return;

    let productIds: string[];
    try {
      productIds = JSON.parse(productIdsJson);
    } catch {
      return;
    }

    productIds.forEach((id) => {
      const checkbox = document.querySelector(`#compare-${id}`) as HTMLInputElement;
      if (!checkbox) return;
      checkbox.checked = true;
    });
  };

  setupCheckboxEvents = () => {
    const comparisonCheckboxes = document.querySelectorAll('.thule-checkbox.compare input');
    comparisonCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', (event) => {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
          this.tryAddToComparison(checkbox.dataset.productId!, checkbox);
        } else {
          this.removeFromComparison(checkbox.dataset.productId!);
        }
      });
    });

    document.addEventListener(this.PRODUCT_REMOVED_MODAL_EVENT, () => {
      this.resetCheckboxes();
      this.setupCheckboxes();
    });
  };

  resetCheckboxes = () => {
    const checkboxes = document.querySelectorAll('.thule-checkbox.compare input');

    checkboxes.forEach((elem) => {
      const checkbox = elem as HTMLInputElement;
      checkbox.checked = false;
    });
  };

  tryAddToComparison = (productId: string, checkbox: HTMLInputElement) => {
    if (!localStorage.getItem(this.subcategoryId)) localStorage.setItem(this.subcategoryId, JSON.stringify([]));

    let comparisonList: string[];
    try {
      comparisonList = JSON.parse(localStorage.getItem(this.subcategoryId)!);
    } catch {
      comparisonList = [];
    }

    // Already selected - don't let a re-fired change event add it twice.
    if (comparisonList.includes(productId)) return;

    const allowedCount = window.innerWidth < 768 ? 2 : 4;

    if (comparisonList.length >= allowedCount) {
      checkbox.checked = false;
      return;
    }

    comparisonList.push(productId);
    localStorage.setItem(this.subcategoryId, JSON.stringify(comparisonList));
    document.dispatchEvent(new Event(this.CHECKBOX_CHECKED_EVENT));
  };

  removeFromComparison = (productId: string) => {
    let comparisonList: string[];
    try {
      comparisonList = JSON.parse(localStorage.getItem(this.subcategoryId)!);
    } catch {
      comparisonList = [];
    }
    const updatedList = comparisonList.filter((id) => id !== productId);

    if (updatedList.length === 0) {
      localStorage.removeItem(this.subcategoryId);
    } else {
      localStorage.setItem(this.subcategoryId, JSON.stringify(updatedList));
    }

    document.dispatchEvent(new Event(this.CHECKBOX_CHECKED_EVENT));
  };
}

document.addEventListener('DOMContentLoaded', () => {
  new ComparisonTool();
});
